// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterCloseButton_wrapper__7N1Ot","warningModal":"FooterCloseButton_warningModal__Fef46"};